import _regeneratorRuntime from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import helper from '@/libs/helper.js';
import axios from '@/plugin/axios';
import util from '@/libs/util.js';
export default {
  data: function data() {
    return {
      next: [],
      today: [],
      date: '',
      week: [],
      reserve: [],
      write: [],
      powerCode: localStorage['apcode'],
      isRoot: localStorage['is_root'],
      place: {}
    };
  },
  created: function created() {
    this.getCurrentTeamMessage();
    // console.log('this', this.$store)
  },

  methods: {
    loadData: function loadData() {},
    getCurrentTeamMessage: function getCurrentTeamMessage() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, res, lastMsgId, that;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = helper.apiHost + helper.apiUrl.getTeamMessage;
              _context.next = 3;
              return axios({
                url: url,
                method: 'post',
                data: {
                  admin_id: localStorage['admin_id']
                }
              });
            case 3:
              res = _context.sent;
              //更新未读站内信数量
              _this.$store.dispatch('d2admin/user/setMsgCount', res.data.count, {
                root: true
              });
              //判断最新消息id
              lastMsgId = sessionStorage.getItem("msg_id");
              if (!lastMsgId) {
                lastMsgId = 0;
              }
              if (lastMsgId != res.data.lastId) {
                //弹窗提醒
                that = _this;
                sessionStorage.setItem("msg_id", res.data.lastId);
                _this.$notify({
                  title: '站内信提醒',
                  message: '您有' + res.data.count + '站内信未读，点击跳转查看',
                  position: 'bottom-right',
                  duration: 2000,
                  onClick: function onClick() {
                    that.$router.push({
                      path: '/message'
                    });
                  }
                });
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};